module.exports = __webpack_public_path__ + "static/media/default-message-background.e1d580b7.png";